import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fire when the photo gallery is loaded.
 *
 * &nbsp;
 */
export class PhotoGalleryLoadedEvent extends AnalyticsEvent {
  eventName = 'photo-gallery-loaded';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;
}
